import axiosInstance from 'api/axios';
import { botFormInputs } from '../components/GetStarted/BotInfoForm';
import {
  Bot,
  createBotResponse,
  getAllBotsResponse,
} from '../types/apiResponses';
import { queryClient } from '../../../index';

export const botOperationServices = {
  // to create a bot
  createBot: async (data: botFormInputs): Promise<createBotResponse> => {
    const response = await axiosInstance.private.post(
      `/api/v1/tele/bots`,
      data
    );

    return response.data;
  },

  // to get all bots
  getAllBots: async (): Promise<getAllBotsResponse> => {
    const response = await axiosInstance.private.get(`/api/v1/tele/bots`);

    return response.data;
  },

  // update bot working
  updateBot: async (id: string, data: Partial<Bot>): Promise<Bot> => {
    const response = await axiosInstance.private.put(
      `/api/v1/tele/bots/${id}`,
      data
    );

    return response.data;
  },

  deleteBot: async (id: string) => {
    const response = await axiosInstance.private.delete(
      `/api/v1/tele/bots/${id}`
    );

    void queryClient.invalidateQueries({ queryKey: ['bot-history'] });

    return response.data;
  },
};
